import { isEmptyArray } from '../../../../utils/array-utils';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
export const getInProgressItem = () => {
    /**
     * Currently, all the inProgressItems in the store refer to the same item.
     * The number of inProgressItems in the list is used to calculate selection quantity and later on created as separate order items.
     * */
    if (isEmptyArray(temporaryOrderDomainStore.data.inProgressItems))
        return undefined;
    return temporaryOrderDomainStore.data.inProgressItems[0];
};
